import type { FC, MouseEventHandler, ReactElement } from 'react';
import React from 'react';
import cx from 'classnames';
import type {
	PopoverContentProps as RadixPopperContentProps,
	PopoverProps as RadixPopoverProps,
} from '@radix-ui/react-popover';
import { Content, Portal, Root, Trigger } from '@radix-ui/react-popover';

import { applyCypressData } from 'Utilities/helpers';

import styles from './Popover.module.scss';

export interface PopoverProps {
	content: ReactElement | string;
	contentAlign?: RadixPopperContentProps['align'];
	contentClassName?: string;
	contentOnClick?: MouseEventHandler<HTMLDivElement>;
	contentOnPointerDownOutside?: Noop;
	contentSide?: RadixPopperContentProps['side'];
	contentSideOffset?: number;
	cypressId?: string;
	modal?: RadixPopoverProps['modal'];
	onOpenChange?: RadixPopoverProps['onOpenChange'];
	open?: RadixPopoverProps['open'];
	trigger: ReactElement | string;
}

const Popover: FC<PopoverProps> = ({
	content,
	contentAlign,
	contentClassName,
	contentOnClick,
	contentOnPointerDownOutside,
	contentSide,
	contentSideOffset,
	cypressId,
	modal,
	onOpenChange,
	open,
	trigger,
}) => (
	<Root modal={modal} onOpenChange={onOpenChange} open={open}>
		<Trigger asChild={typeof trigger !== 'string'}>{trigger}</Trigger>
		<Portal>
			<Content
				{...applyCypressData(cypressId)}
				align={contentAlign}
				className={cx(styles.popoverContent, contentClassName)}
				data-testid="popover-content"
				onClick={contentOnClick}
				onPointerDownOutside={contentOnPointerDownOutside}
				side={contentSide}
				sideOffset={contentSideOffset}
			>
				{content}
			</Content>
		</Portal>
	</Root>
);

export default Popover;
